import { render, staticRenderFns } from "./FactorySettingsDialog.vue?vue&type=template&id=511c1946"
import script from "./FactorySettingsDialog.vue?vue&type=script&lang=js"
export * from "./FactorySettingsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports